import chatModule from '../chatModule';

function chatBarController($scope, $log, chatClientStorageUtilityService, chatUtility) {
    "ngInject";


    $scope.cancelSearch = function () {
        $scope.chatViewModel.searchTerm = "";
        $scope.chatLibrary.chatLayout.searchFocus = false;
    }

    $scope.saveChatBarLayoutInCookie = function () {
        var chatBarLayout = {
            collapsed: $scope.chatLibrary.chatLayout.collapsed
        };
        chatClientStorageUtilityService.updateStorage(chatClientStorageUtilityService.storageDictionary.chatBarLayout, chatBarLayout, $scope.chatLibrary.cookieOption);
    }

    $scope.toggleChatContainer = function () {
        $scope.chatLibrary.chatLayout.collapsed = !$scope.chatLibrary.chatLayout.collapsed;
        $scope.updateUnreadConversationCount();
        $scope.chatLibrary.chatLayout.chatBarInitialized = true;
        $scope.saveChatBarLayoutInCookie();
    }

    $scope.isChatDisconnected = function () {
        const { chatLayout: { isChatEnabledByPrivacySetting, errorMaskEnable, pageDataLoading } } = $scope.chatLibrary;
        const { chatEnabledByPrivacySettingTypes } = chatUtility;
        return (isChatEnabledByPrivacySetting === chatEnabledByPrivacySettingTypes.enabled)
            && (errorMaskEnable || pageDataLoading);
    }

    $scope.isChatEmpty = function () {
        const { chatLayout: { isChatEnabledByPrivacySetting, chatLandingEnabled } } = $scope.chatLibrary;
        const { chatEnabledByPrivacySettingTypes } = chatUtility;
        return chatLandingEnabled || isChatEnabledByPrivacySetting !== chatEnabledByPrivacySettingTypes.enabled;
    }

    $scope.search = function (item) {
        const { searchTerm } = $scope.chatViewModel;
        if (!searchTerm) {
            return true;
        }
        const { name, contact } = item;
        const searchTermLowerCase = searchTerm.toLowerCase();

        return name.toLowerCase().indexOf(searchTermLowerCase) !== -1
            || (contact && contact.toLowerCase().indexOf(searchTermLowerCase) !== -1);
    };
};

chatModule.controller("chatBarController", chatBarController);

export default chatBarController;